import {Controller} from '@hotwired/stimulus'

// Client-side name filter for the skills list. The list is fully server-rendered,
// so filtering is a show/hide pass over rows already in the DOM — each row carries
// its downcased name in data-name.
export default class extends Controller {
  static targets = ['input', 'row']

  connect() {
    this.filter()
  }

  filter() {
    if (!this.hasInputTarget)
      return

    const query = this.inputTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      const name = row.dataset.name || ''
      row.hidden = query !== '' && !name.includes(query)
    })
  }
}
